/**
 * Created by chenzheyu on 2017/7/9.
 */

import XkUpAvatar from './src/upAvatar.vue'

XkUpAvatar.install = function (Vue) {
  Vue.component(XkUpAvatar.name, XkUpAvatar)
}

export default XkUpAvatar



// WEBPACK FOOTER //
// ./src/components/module/upAvatar/index.js